<app-header-simple
  [hidden]="loading"
  [title]="'lista de indicados'"
  [showBtnBack]="true"
  [isModal]="true"
  (evtGoBack)="dismissModal()"
></app-header-simple>

<ion-content [hidden]="loading">
  <div class="content">
    <h2>Confira todos os seus indicados</h2>
    <ion-segment [(ngModel)]="selectTabs" value="users">
      <ion-segment-button value="users">
        <ion-label>Usuários</ion-label>
      </ion-segment-button>
      <ion-segment-button value="companies">
        <ion-label>Negócios</ion-label>
      </ion-segment-button>
    </ion-segment>

    <h1
      [hidden]="
        (selectTabs === 'users' && userIndicateds?.indicatedUsers) ||
        (selectTabs === 'companies' && userIndicateds?.indicatedCompanies)
      "
    >
      Ainda não há registros
    </h1>

    <div class="content-users" *ngIf="selectTabs === 'users'">
      <ion-grid>
        <ion-row *ngFor="let user of userIndicateds?.indicatedUsers">
          <ion-col size="auto"><span>Nome: </span>{{ user.name }} </ion-col>
          <ion-col size="auto"><span>E-mail: </span>{{ user.email }}</ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="content-companies" *ngIf="selectTabs === 'companies'">
      <ion-grid>
        <ion-row *ngFor="let user of userIndicateds?.indicatedCompanies">
          <ion-col size="auto"><span>Nome: </span>{{ user.name }} </ion-col>
          <ion-col size="auto"><span>E-mail: </span>{{ user.email }}</ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>
